import { BagClickEvent } from '@/services/analytics/events';
import Vue from 'vue';

Vue.directive('track-bag-click', {
  inserted(el, binding, vnode) {
    el.addEventListener('click', () => {
      vnode.context?.$services.analytics.send(new BagClickEvent(binding.arg || '', vnode.context.$services.order.getCurrentOrder()?.order.meals));
    });
  },
});
